import { IFeatureBoxes } from "@/api/AppApi/services/home/interfaces/IFeatureBox";
import { Col, Row } from "@/utils/bootstrap";
import FeatureBox from "./FeatureBox";

interface Props extends IFeatureBoxes {}

const part = (arr: any[], size: number): any[][] =>
  arr.reduce(
    (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
    []
  );

const MobileFeatureBoxes = (props: Props) => {
  const data = props.data ?? [];
  const chunks = part(data ?? [], 2);
  return (
    <Row className="m-0 feature-box-container" style={{ gap: 1 }}>
      {chunks.map((chunk, key) => (
        <Row key={key} style={{ margin: 0, padding: 0, gap: 1 }}>
          {chunk.map((child, key) => (
            <Col className="p-0" key={key}>
              <FeatureBox isMobile {...child} isOdd={chunk.length === 1} />
            </Col>
          ))}
        </Row>
      ))}
    </Row>
  );
};

export default MobileFeatureBoxes;
